import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { SubscriptionListingState } from "../../../../models/state";

const fulfilled = (actionType: string) => {
    return `${actionType}_FULFILLED`;
};

const initialState = (): SubscriptionListingState => ({
    subscriptions: [],
    subscriptionsYoung: [],
    hiddenSubscriptionsOfferingCodes: [],
    hiddenSubscriptionsYoungOfferingCodes: [],
    teliaTryggSubscriptions: [],
});

const reducer = (state = initialState(), action: AnyAction): SubscriptionListingState => {
    switch (action.type) {
        case fulfilled(AT.SUBSCRIPTION_LISTING_GET_SUBSCRIPTIONS): {
            return {
                ...state,
                subscriptions: action.payload.subscriptions || [],
                subscriptionsYoung: action.payload.subscriptionsYoung || [],
                hiddenSubscriptionsOfferingCodes: action.payload.hiddenSubscriptionsOfferingCodes || [],
                hiddenSubscriptionsYoungOfferingCodes: action.payload.hiddenSubscriptionsYoungOfferingCodes || [],
                teliaTryggSubscriptions: action.payload.teliaTryggSubscriptions || [],
            };
        }
        default:
            return state;
    }
};

export default reducer;
